export default object => {
    let formsValid = false;
    let formOneValid = false;
    let formTwoValid = false;
    let purpose;
    let deliverable;
    let addlDeliverables;
    // Event information
    if (typeof object.purpose === 'string') {
        purpose = object.purpose.trim();
    } else {
        purpose = object.purpose;
    }
    if (typeof object.deliverable === 'string') {
        deliverable = object.deliverable.trim();
    } else {
        deliverable = object.deliverable;
    }
    if (typeof object.addlDeliverables === 'string') {
        addlDeliverables = object.addlDeliverables.trim();
    } else {
        addlDeliverables = object.addlDeliverables;
    }
    if (
        object.name &&
        object.sDate &&
        object.startTime &&
        object.eDate &&
        object.endTime &&
        object.city &&
        object.isFromEac &&
        object.contract &&
        object.category.length > 0 &&
        object.fiscalYear
    ) {
        if (object.showParentIdField) {
            if (object.showParentIdField === '1' && object.parentId) {
                formOneValid = true;
            } else if (object.showParentIdField === '0') {
                formOneValid = true;
            }
        }
    }

    // Form information
    if (
        purpose !== '' &&
        object.estAttendance !== null &&
        object.estEngagements !== null &&
        object.estMediaPosts !== null &&
        object.estMediaImpressions !== null &&
        object.estSocialMediaPosts !== null &&
        object.estSocialMediaImpressions !== null &&
        object.estQualifiedLeads !== null &&
        object.estInfluencerContacts !== null &&
        object.estFollowUps !== null &&
        object.estInteraction !== null &&
        object.estInfluencerInteraction !== null &&
        object.estOnsiteActivations !== null &&
        deliverable !== '' &&
        addlDeliverables !== ''
    ) {
        formTwoValid = true;
    }

    if (formOneValid && formTwoValid) {
        formsValid = true;
    }

    const formsValidObj = {
        formOneValid,
        formTwoValid,
        formsValid
    };
    return formsValidObj;
};



// WEBPACK FOOTER //
// ./src/helpers/crossFormValidation.js